var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择数据源" },
                        on: { change: _vm.search },
                        model: {
                          value: _vm.q.dsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.q, "dsName", $$v)
                          },
                          expression: "q.dsName",
                        },
                      },
                      _vm._l(_vm.dataSourceList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.name },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 4 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "表名称" },
                      model: {
                        value: _vm.q.tableName,
                        callback: function ($$v) {
                          _vm.$set(_vm.q, "tableName", $$v)
                        },
                        expression: "q.tableName",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-search", type: "primary" },
                        on: { click: _vm.search },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-download", type: "primary" },
                        on: { click: _vm.openBatch },
                      },
                      [_vm._v("批量生成")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              data: _vm.tableData,
              option: _vm.tableOption,
              page: _vm.page,
              "table-loading": _vm.tableLoading,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "refresh-change": _vm.refreshChange,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-view", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleTable(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("字段")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-check", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDown(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("生成")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-edit", type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDesign(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("设计")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.box,
                "lock-scroll": "",
                title: "生成配置",
                width: "50%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.box = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "pull-auto" },
                [
                  _c("avue-form", {
                    ref: "formData",
                    attrs: { option: _vm.formOption },
                    scopedSlots: _vm._u([
                      {
                        key: "menuForm",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-view",
                                  plain: "",
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleView()
                                  },
                                },
                              },
                              [_vm._v("预览")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-check",
                                  plain: "",
                                  type: "info",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.gen()
                                  },
                                },
                              },
                              [_vm._v("下载")]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.formData,
                      callback: function ($$v) {
                        _vm.formData = $$v
                      },
                      expression: "formData",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.boxBatch,
                "lock-scroll": "",
                title: "批量生成",
                width: "50%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.boxBatch = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "pull-auto" },
                [
                  _c("avue-form", {
                    ref: "formBatchData",
                    attrs: { option: _vm.formBatchOption },
                    on: { submit: _vm.batchGen },
                    model: {
                      value: _vm.formBatchData,
                      callback: function ($$v) {
                        _vm.formBatchData = $$v
                      },
                      expression: "formBatchData",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.preview.title,
            visible: _vm.preview.open,
            "append-to-body": "",
            top: "5vh",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.preview, "open", $event)
            },
          },
        },
        [
          _vm.preview.open
            ? _c("Preview", { attrs: { queryData: this.formData } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.table.title,
            visible: _vm.table.open,
            "append-to-body": "",
            top: "5vh",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.table, "open", $event)
            },
          },
        },
        [
          _vm.table.open
            ? _c("Table", { attrs: { queryData: this.formData } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }